
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import firebase from 'firebase'
import { db, storageRef } from '@/main'
import mixin from '../../mixin'
//import colombiaCities from '@/models/colombia.ts'
import axios from 'axios'
import { URL_CLOUD_FUNCTIONS } from '@/firebase/init'
//import { URL_CLOUD_FUNCTIONS, KEY_MESSAGES, TOKEN_PUSH } from '@/firebase/init'

let app
@Component
export default class DialogAddnewUser extends mixins(mixin) {
  newUser = {
    names: '',
    last_names: '',
    genre: 'Masculino',
    birthday: '',
    email: '',
    country: 'Colombia',
    state: 'Santander',
    city: 'Bucaramanga',
    image: '',
    occupation: '',
    premium: false,
    creation_date: '',
  }
  defaultUser = {
    names: '',
    last_names: '',
    genre: 'Masculino',
    birthday: '',
    email: '',
    country: 'Colombia',
    state: 'Santander',
    city: 'Bucaramanga',
    image: '',
    occupation: '',
    premium: false,
    creation_date: '',
  }
  openRangeModal = false
  closeRangeModal = false
  openRange = ''
  closeRange = ''
  departments: any[] = []
  cities: any[] = []
  center = { lat: 9.929405, lng: -84.091424 }
  markerPosition = { lat: 9.929405, lng: -84.091424 }
  names = ''

  dialogAddNewUser = false
  nameRules = [
    (v) => (v != undefined ? !!v || 'Los nombres son obligatorios' : ''),
    (v) =>
      v != undefined
        ? v.length > 2 || 'Los nombres deben tener mas de 2 caracteres'
        : '',
  ]
  lastNameRules = [
    (v) => (v != undefined ? !!v || 'Los apellidos son obligatorios' : ''),
    (v) =>
      v != undefined
        ? v.length > 2 || 'Los apellidos deben tener mas de 2 caracteres'
        : '',
  ]
  emailRules = [
    (v) => !!v || 'El E-mail es obligatorio',
    (v) => /.+@.+\..+/.test(v) || 'El E-mail debe ser válido',
  ]
  phoneRules = [
    (v) => (v != undefined ? !!v || 'El teléfono es obligatorio' : ''),
    (v) =>
      v != undefined
        ? v.length === 7 || 'El teléfono debe tener 7 números'
        : '',
  ]
  cellphoneRules = [
    (v) => (v != undefined ? !!v || 'El celular es obligatorio' : ''),
    (v) =>
      v != undefined
        ? v.length === 10 || 'El celular debe tener 10 números'
        : '',
  ]
  selectedImage: File = new File([''], '')
  mounted() {
    // console.log(colombiaCities)
    // colombiaCities.forEach(value => {
    //   this.departments.push(value.departamento)
    // })
    app = this
  }

  @Watch('newUser.department')
  onNewUserDepartmentChange(val) {
    this.cities = []
    // colombiaCities.forEach(value => {
    //   if (value.departamento === val) {
    //     for (const data of value.ciudades) {
    //       this.cities.push(data)
    //     }
    //   }
    // })
  }

  updateCenter(center) {
    console.log(center)
    this.center = {
      lat: center.lat,
      lng: center.lng,
    }
    this.markerPosition = this.center
  }

  openDialogAddnewUser() {
    this.dialogAddNewUser = true
  }

  onSelectedImageChange(val) {
    console.log(val)
    this.selectedImage = val
  }

  async createUser() {
    this.showNotification('loading', 'Creando usuario', 'Un momento por favor')
    const finalUser = JSON.parse(JSON.stringify(this.newUser))
    const url = URL_CLOUD_FUNCTIONS + 'createUser'
    try {
      const res = await axios.post(url, finalUser)
      console.log(res)
      this.showNotification('success', 'Éxito', 'Usuario Creado')
      this.dialogAddNewUser = false
      app.newUser = JSON.parse(JSON.stringify(this.defaultUser))
      app.$refs.formAddClient.reset()
      return res
    } catch (error) {
      console.log(error)
      this.showNotification(
        'fail',
        'Error',
        'OCurrió un error al crear el usuario'
      )
    }
  }
}
